<template>
  <div class="bg-image">
    <router-view></router-view>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.bg-image {
  padding: 148px 16px;
  background: url("/assets/image/vgas/login-bg.jfif") lightgray 50% / cover
    no-repeat;
    background-repeat: no-repeat;
    background-size: cover;
}
</style>